import script from "./personal_information_cmp.vue?vue&type=script&setup=true&lang=js"
export * from "./personal_information_cmp.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__